import _ from 'lodash'
import type {Experiment, RunningExperiments} from '@wix/document-services-types'
import {CoreConfig, createDMCore} from '../src/documentManagerCore'
import {newSchemaService} from '@wix/document-services-json-schemas'
import {createTestExperimentInstance, getDefaultExperiments} from './testkit/experiments'
import {createTestLogger} from './testkit/testLogger'
import {createTestDal, defaultFragmentType, defaultType, dalUtils} from './testkit/testDal'
import type {CoreLogger} from '../src/index'
import {validationService} from '@wix/dm-validation'

interface CoreArgs {
    experimentInstance?: Experiment
    logger?: CoreLogger
    experimentOverrides?: RunningExperiments
    coreConfigOverrides?: Partial<CoreConfig>
}

const createTestCore = ({experimentInstance, logger, experimentOverrides, coreConfigOverrides}: CoreArgs = {}) => {
    const experiment = experimentInstance ?? createTestExperimentInstance(experimentOverrides)
    const _logger = logger ?? createTestLogger()

    return createDMCore(
        _.merge(
            {
                experimentInstance: experiment,
                logger: _logger,
                schemaService:
                    coreConfigOverrides?.schemaService ??
                    newSchemaService.getInstanceByExperiments(experiment, {
                        enforceStrictValidationEverywhere: coreConfigOverrides?.enforceStrictValidationEverywhere,
                        enforceNoWhitelistDalStrictSchemaValidation:
                            coreConfigOverrides?.enforceNoWhitelistDalStrictSchemaValidation
                    }),
                validationService: validationService.staticInstance,
                signatureSeed: 'sig',
                supportedFragments: {
                    FragmentIndex: {
                        loadOnInit: true
                    },
                    AppState: {
                        loadOnInit: true
                    }
                },
                transactionActionsLimit: 500,
                minNumOfPagesToCalculateRenderHints: 0
            },
            coreConfigOverrides
        )
    )
}

export {
    defaultFragmentType,
    defaultType,
    dalUtils,
    createTestCore,
    createTestExperimentInstance,
    createTestLogger,
    getDefaultExperiments,
    createTestDal
}
